import React from "react";
import style from "../Style.module.css";

const Pattern5 = ({ color = "#2F2F2F", width = "100%", height = "100%" }) => {
  return (
    <svg
      className={style.svgBackground}
      width={width}
      height={height}
      viewBox="0 0 312 351"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        d="M155.5 0C55.2585 0 -26 83.0494 -26 185.5C-26 287.951 55.2585 371 155.5 371C255.741 371 337 287.951 337 185.5C337 83.0494 255.741 0 155.5 0ZM252.933 217.868C272.981 244.496 246.734 281.517 215.742 270.232C216.613 303.887 174.096 318.042 155.5 290.227C136.904 317.943 94.3866 303.887 95.2583 270.232C64.2657 281.517 37.9221 244.496 58.0672 217.868C26.4936 208.366 26.4936 162.634 58.0672 153.132C38.0189 126.504 64.2657 89.4835 95.2583 100.768C94.3866 67.1126 136.904 52.9576 155.5 80.7727C174.096 53.0566 216.613 67.1126 215.742 100.768C246.734 89.4835 273.078 126.504 252.933 153.132C284.603 162.634 284.603 208.366 252.933 217.868Z"
        fill={color}
        opacity={0.1}
      />
    </svg>
  );
};

export default Pattern5;
